import type { GetDefaultRolesResponseRow } from '@risksmart-app/drizzle/src/dto';
import type { GetDefaultRolesQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetDefaultRolesDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createQueryHook } from 'src/utils';

const mapTrpcRoleToGraphQL = (
  role: GetDefaultRolesResponseRow
): GetDefaultRolesQuery['auth_role_type'][number] => ({
  ...role,
  resourceTypes: (role.resourceTypes ?? [])
    .filter((resourceType) => resourceType.resourceType != null)
    .map((resourceType) => ({
      ...resourceType,
      resourceType: {
        ResourceType: resourceType.resourceType!.ResourceType,
      },
    })),
});

const mapTrpcRolesToGraphQL = (
  data: GetDefaultRolesResponseRow[]
): GetDefaultRolesQuery => ({
  auth_role_type: data.map(mapTrpcRoleToGraphQL),
});

export const useGetDefaultRoles = createQueryHook<
  Record<string, never>,
  GetDefaultRolesResponseRow[],
  GetDefaultRolesQuery
>({
  trpcQueryOptions: (trpc) => trpc.frontend.role.getDefaultRoles.queryOptions(),
  mapTrpcDataToGraphQL: mapTrpcRolesToGraphQL,
  graphqlDocument: GetDefaultRolesDocument,
});
